import { createApi } from '@reduxjs/toolkit/query/react';

import { axiosBaseQuery } from './axiosBaseQuery';

// Our app has a single API slice object that handles all server communication.
// Endpoints are injected into it from other feature files so the slice stays
// in one place while the endpoint definitions live next to the components
// that use them (see RTK Query docs: "Code Splitting and Generation").
export const apiSlice = createApi({
  // The cache reducer expects to be registered at `state.api`
  // (whatever default we get from `getDefaultMiddleware()`)
  reducerPath: 'api',
  // All of our requests will go through our pre-configured Axios instance
  // (CSRF token injection, session auth, error handling).
  baseQuery: axiosBaseQuery,
  // Tag types must be declared here so that query ↔ mutation invalidation
  // relationships can be expressed across injected endpoint files.
  tagTypes: [
    // Variant check (search / list)
    'Variants',

    // Variant core
    'VariantDetail',
    'VariantStages',
    'VariantComments',
    'VariantHistory',

    // Clinical observation
    'Samples',
    'SampleFilterOptions',
    'VariantSamples',
    'VariantDatabases',
    'ClinvarRecord',
    'ClinvarAssertions',
    'MedicalInvestigations',

    // Frequency data
    'VariantFrequencies',
    'GeneTopPatVarFrequencies',
    'MaxAFScorings',

    // Molecular impact
    'MolecularImpactHeader',
    'VariantPredictions',
    'SpliceSiteAlteration',
    'ProteinDomains',
    'OtherVariants',
    'ClinVarHotSpot',
    'ClinVarHotSpotVariantList',
    'ClinVarGeneDistribution',

    // Interpretation
    'InterpretationZone',
    'VariantArguments',
    'GeneFactsOverview',
    'InterpretationSnapshots',

    // References & linkouts
    'VariantReferences',
    'VariantLinkouts',
    'VariantTranscripts',

    // Global / reference data
    'GlobalData',
    'Gene',
    'Evaluation',
    'EvaluationValues',

    // User profile (cached via getUserDetails endpoint, cleared on logout)
    'UserProfile',
    'RunningTasks',
  ],
  // Endpoints are empty here; they are injected via `apiSlice.injectEndpoints`
  // in co-located files (e.g. `variantApi.ts`, `globalDataApi.ts`).
  endpoints: () => ({}),
});
